import {
  CommonDataActionConst,
  ChangeMaintenenceStep,
  ChangeBroadcastStepActionConst,
  GetAllActiveChatsActionConst,
  selectedSessionIdActionConsy,
  GetCurrentShiftActionConst,
  ShiftCheckOutHandlerConst,
  SelectedSessionIdActionConst,
  GetAllCompletedChatSessionsActionConst,
  selectedCompletedSessionIdActionConsy,
} from "../../constants/DataActionConst";
import BaseUrl from "../../../constants/BaseUrl";

export const ChangeMaintenanceCurrentStep = (step) => {
  return async (dispatch) => {
    dispatch({
      type: ChangeMaintenenceStep.CHANGE_MAINTENANCE_STEP,
      step: step,
    });
  };
};

export const ShiftCheckOutHandler = (step) => {
  return async (dispatch) => {
    dispatch({
      type: ShiftCheckOutHandlerConst.SHIFT_CHECKOUT,
    });
  };
};

export const SelectedPrevSessionIdAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: SelectedSessionIdActionConst.SELECTED_SESSION_ID,
      id: id,
    });
  };
};

export const SelectedComplatedSessionIdAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: selectedCompletedSessionIdActionConsy.SELECTED_COMPLETED_CHAT_ID,
      id: id,
    });
  };
};

export const GetAllActiveChatSessions = (id, loginSuccess) => {
  return async (dispatch) => {
    dispatch({
      type: GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_REQ,
    });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getChatSessionsBySessionId/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_SUCC,
            data: result.data,
          });
        } else {
          dispatch({
            type: GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_FAIL,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const GetAllCompletedChatSessionsAction = (id, loginSuccess) => {
  return async (dispatch) => {
    dispatch({
      type: GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_REQ,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getCompltedChatSessionsBySessionId/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_SUCC,
            data: result.data,
          });
        } else {
          dispatch({
            type: GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_FAIL,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const GetAllTechnicalCompletedChatSessionsAction = (
  id,
  loginSuccess
) => {
  return async (dispatch) => {
    dispatch({
      type: GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_REQ,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getCompltedTechnicalChatSessionsBySessionId/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_SUCC,
            data: result.data,
          });
        } else {
          dispatch({
            type: GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_FAIL,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const GetAllActiveChatSessionsTechnical = (id, loginSuccess) => {
  return async (dispatch) => {
    dispatch({
      type: GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_REQ,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getChatSessionsByTechnicalSessionId/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          console.log(result, "---");
          dispatch({
            type: GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_SUCC,
            data: result.data,
          });
        } else {
          dispatch({
            type: GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_FAIL,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const selectedSessionIdAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: selectedSessionIdActionConsy.SELECTED_CHAT_ID,
      id: id,
    });
  };
};

export const GetAllMasterData = () => {
  return async (dispatch) => {
    dispatch({
      type: CommonDataActionConst.GET_COMMON_MASTER_DATA_REQ,
    });

    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/master/commonData`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          let propertyData = result.commonMasterData.propertyTypes;
          for (const key in propertyData) {
            if (propertyData[key].category === "Residential") {
              propertyData[key]["activeImage"] = "resedential-color.png";
              propertyData[key]["inActiveImage"] = "resedential.png";
              let typeLIst = propertyData[key].types;
              for (const i in typeLIst) {
                if (typeLIst[i].name === "Single") {
                  typeLIst[i]["imagePath"] = "single.png";
                  typeLIst[i]["imagePathActive"] = "single-color.png";
                } else if (typeLIst[i].name === "Multi Family") {
                  typeLIst[i]["imagePath"] = "family.png";
                  typeLIst[i]["imagePathActive"] = "family-color.png";
                } else if (typeLIst[i].name === "Condo") {
                  typeLIst[i]["imagePath"] = "condo.png";
                  typeLIst[i]["imagePathActive"] = "condo-color.png";
                } else if (typeLIst[i].name === "Town Home") {
                  typeLIst[i]["imagePath"] = "town.png";
                  typeLIst[i]["imagePathActive"] = "town-color.png";
                } else {
                  typeLIst[i]["imagePath"] = "other.png";
                  typeLIst[i]["imagePathActive"] = "other-color.png";
                }
              }
            } else {
              propertyData[key]["activeImage"] = "commercial-color.png";
              propertyData[key]["inActiveImage"] = "commercial.png";
              let typeLIst = propertyData[key].types;
              for (const i in typeLIst) {
                if (typeLIst[i].name === "Flex category") {
                  typeLIst[i]["imagePath"] = "office.png";
                  typeLIst[i]["imagePathActive"] = "office-color.png";
                } else if (typeLIst[i].name === "Retail Space") {
                  typeLIst[i]["imagePath"] = "reatilSpace.png";
                  typeLIst[i]["imagePathActive"] = "reatilSpace-color.png";
                } else if (typeLIst[i].name === "Industrial") {
                  typeLIst[i]["imagePath"] = "industry.png";
                  typeLIst[i]["imagePathActive"] = "industry-color.png";
                } else if (typeLIst[i].name === "Warehouse") {
                  typeLIst[i]["imagePath"] = "warehouse.png";
                  typeLIst[i]["imagePathActive"] = "warehouse-color.png";
                } else if (typeLIst[i].name === "Hospitality") {
                  typeLIst[i]["imagePath"] = "hospitality.png";
                  typeLIst[i]["imagePathActive"] = "hospitality-color.png";
                } else {
                  typeLIst[i]["imagePath"] = "other.png";
                  typeLIst[i]["imagePathActive"] = "other-color.png";
                }
              }
            }
          }

          dispatch({
            type: CommonDataActionConst.GET_COMMON_MASTER_DATA_SUCCESS,
            result: result.commonMasterData,
            propertyData: propertyData,
          });
        } else {
          // alert("ERROR=", JSON.stringify(result))
          dispatch({
            type: CommonDataActionConst.GET_COMMON_MASTER_DATA_FAIL,
          });
        }
      })
      .catch((error) => console.error(error));

    return;
  };
};

export const GetCurrentShiftAction = (id, token) => {
  return async (dispatch) => {
    dispatch({
      type: GetCurrentShiftActionConst.GET_CURRENT_SHIFT_REQ,
    });

    const getUser = localStorage.getItem("loginSuccess");
    const getToken = JSON.parse(getUser)?.token;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${getToken || token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    // fetch(`${BaseUrl}api/support/getShiftsByDate?date=${formattedDate}&supportStaffId=${id}`, requestOptions)

    fetch(
      `${BaseUrl}api/support/getRecentShiftslast24hrBySupportStaffId?supportStaffId=${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: GetCurrentShiftActionConst.GET_CURRENT_SHIFT_SUCC,
            data: result?.data,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const ChangeBroadcastCurrentStep = (step) => {
  return async (dispatch) => {
    dispatch({
      type: ChangeBroadcastStepActionConst.CHANGE_BROADCAST_STEP,
      step: step,
    });
  };
};

export const updateActiveChatSession = (sessions, newSession) => {
  const index = sessions.findIndex((session) => session._id === newSession._id);
  if (index !== -1) {
    const updatedSessions = [...sessions];
    updatedSessions[index] = {
      ...updatedSessions[index],
      ...newSession,
      conversation: [
        ...updatedSessions[index].conversation,
        ...newSession.conversation,
      ],
    };
    return updatedSessions;
  } else {
    return [newSession, ...sessions];
  }
};

export const addMessageToSession = (sessionId, messageObj) => {
  return {
    type: GetAllActiveChatsActionConst.UPDATE_ACTIVE_CHAT_SESSION,
    data: {
      sessionId,
      messageObj,
    },
  };
};

export const updateChatSession = (sessionData) => {
  return {
    type: GetAllActiveChatsActionConst.UPDATE_ACTIVE_CHAT_SESSION,
    data: sessionData,
  };
};
